import AccountService from "./account/accountService";
import AllocationService from "./allocation/allocationService";
import ContactService from "./contact/contactService";
import CustomDashboardService from "./customDashboard/customDashboardService";
import ExecutiveSummaryService from "./executiveSummary/executiveSummaryService";
import FinanceService from "./finance/financeService";
import MerchantService from "./merchant/merchantService";
import NotificationService from "./notification/notificationService";
import ProductService from "./product/productService";
import SummaryService from "./summary/summaryService";
import AuthenService from "./user/authenService";
import UserService from "./user/userService";
export default {
  AuthenService,
  UserService,
  SummaryService,
  FinanceService,
  AccountService,
  CustomDashboardService,
  AllocationService,
  ContactService,
  ProductService,
  MerchantService,
  ExecutiveSummaryService,
  NotificationService,
};
